// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XJ0F","importantInfo":"styles_importantInfo__2T5i5"};